import { MdArrowBackIos, MdArrowForwardIos } from 'react-icons/md';
import { __PostsFiltersPropsType } from '../../posts.type';
import { GlobalContext } from 'context';
import { CategoryType, ThemeEnum } from 'types';
import { COLORS } from 'utilities';
import { useContext } from 'react';
import styles from './category.module.scss';
import Image from 'next/image';
import { catIconData } from 'data';

export default function CategoryFiltersComp({
    filters,
    setFilters,
    filterData,
}: Required<Omit<__PostsFiltersPropsType, 'onClose'>>) {
    const { theme } = useContext(GlobalContext);
    const onChangeCategory = (category?: CategoryType<'list'>) => {
        setFilters({ ...filters, page: 1, category, categoryFields: undefined, ranges: undefined });
    };

    return (
        <>
            {filters.category ? (
                !filters?.category?.parent ? (
                    <span className="center-content-y g-1 pointer mb-2" onClick={() => onChangeCategory()}>
                        <MdArrowForwardIos size={16} color={theme === ThemeEnum.light ? COLORS.black1 : COLORS.gray3} />
                        <p className="t-p1 t-400 t-l-black1 t-d-gray3-i">همه دسته ها</p>
                    </span>
                ) : (
                    <span
                        className="center-content-y g-1 pointer mb-2"
                        onClick={() => onChangeCategory(filterData.category?.parent)}
                    >
                        <MdArrowForwardIos size={16} color={theme === ThemeEnum.light ? COLORS.black1 : COLORS.gray3} />
                        <p className="t-p1 t-400 t-l-black1 t-d-gray3-i">{filterData.category?.parent?.title}</p>
                    </span>
                )
            ) : (
                <p className="t-p1 t-400 t-l-black1 t-d-gray3-i mb-2">انتخاب دسته</p>
            )}
            {!filters.category ? (
                <div className={`flex-1`}>
                    {filterData.subcategories.map((ctg) => {
                        const Icon = catIconData.find((i) => i.key === ctg.icon);
                        return (
                            <div
                                key={ctg.id}
                                className={`${styles['categories-card']} center-content-y justify-content-between pointer`}
                                onClick={() => onChangeCategory(ctg)}
                            >
                                <div className="center-content-y g-1">
                                    {Icon ? <Icon.icon size={20} className="t-primary" /> : null}
                                    <p className="t-400 t-p2 t-l-black1">{ctg.title}</p>
                                </div>
                                <MdArrowBackIos
                                    size={16}
                                    color={theme === ThemeEnum.light ? COLORS.black1 : COLORS.gray3}
                                />
                            </div>
                        );
                    })}
                </div>
            ) : (
                <div className={`${!filters.category ? 'd-none' : ''} ${styles['first-sub-category']}`}>
                    <div className={`center-content-y g-1 ${filterData.subcategories.length ? 'mb-2' : ''}`}>
                        {filters.category?.image ? (
                            <div className={`${styles['icon']}`}>
                                <Image
                                    src={filters.category.image.file}
                                    width={20}
                                    height={20}
                                    alt={filters.category.title}
                                />
                            </div>
                        ) : null}
                        <p className={`t-400 t-p2 t-l-black1 t-primary-i`}>{filters.category?.title}</p>
                    </div>
                    {filters.category ? (
                        <div className={`${styles['sub-category-layout']} flex-column center-content-x g-1 pr-3`}>
                            {filterData.subcategories.map((i) => (
                                <p
                                    key={i.id}
                                    onClick={() => onChangeCategory(i)}
                                    className={`t-p2 pointer  ${filters.category?.slug === i.slug ? 't-primary-i' : 't-l-gray1-i'}`}
                                >
                                    {i.title}
                                </p>
                            ))}
                        </div>
                    ) : null}
                </div>
            )}
        </>
    );
}
